import PageTitle from "../Components/PageTitle";

import EarCheckUp from "../Assets/EarCheckUp.jpeg"

import '../App.css';

export default function BookingPage() {

  return (
    <div>
      <PageTitle title={"Booking Page"} />

      <div className="flex flex-col gap-y-10 items-center justify-center mt-10 mb-20 w-full lg:w-[60vw] mx-auto">

        <iframe id='cliniko-14447180' src='https://the-ear-nurse.uk3.cliniko.com/bookings?business_id=1938588508906072736&appointment_type_id=1938588506985081490&embedded=true'
          frameborder='0'
          scrolling='auto'
          width='100%'
          height='800'
          style={{ pointerEvents: 'auto' }}
          allow='payment'></iframe>


        <img src={EarCheckUp} className="min-w-[15rem] max-h-[20rem] lg:max-w-[20rem] lg:max-h-[22rem] p-2 lg:mr-10 object-contain" />
      </div>

    </div>
  )
}